import { buildPersonProfilePath } from "../../utils/publicProfileUrls";

/** Public profile URL. The id is the legacy or generated id the profile page loads. */
export function publicStaffProfilePath(staff: {
  name?: string | null;
  lastName?: string | null;
  legacyId?: string | number | null;
  generatedId?: string | number | null;
  isSearchable?: boolean | null;
}): string | null {
  if (staff.isSearchable === false) {
    return null;
  }
  const profileId = String(staff.legacyId ?? "").trim() || String(staff.generatedId ?? "").trim();
  return buildPersonProfilePath(staff.name, staff.lastName, profileId);
}
